import { useTown } from "@/hooks/use-town";

interface TownSelectProps {
  value: string;
  onChange: (town: string) => void;
  className?: string;
  id?: string;
}

export function TownSelect({ value, onChange, className = "", id }: TownSelectProps) {
  const { townGroups } = useTown();
  return (
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`w-full border border-slate-200 rounded-xl px-3 py-2.5 text-sm text-slate-800 outline-none focus:border-primary/50 bg-white appearance-none cursor-pointer ${className}`}
    >
      {townGroups.map((group) => (
        <optgroup key={group.borough} label={group.borough}>
          {group.towns.map((t) => (
            <option key={t.name} value={t.name}>{t.name}</option>
          ))}
        </optgroup>
      ))}
    </select>
  );
}
